<template>
<div class="fc-page ft-page"><nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="ft-breadcrumb"/></nav>
<header class="fc-heading"><div class="fc-child-heading"><h1>优惠券管理</h1><p>管理优惠券面值、使用门槛与有效期</p></div><v-btn @click="showAddDialog" color="#d9363e" depressed class="ft-create"><v-icon left size="18">mdi-plus</v-icon>添加优惠券</v-btn></header>
<section class="fc-filters" aria-label="优惠券管理筛选"><div class="fc-filter-heading"><h3>筛选条件</h3><span>按条件查询当前校区记录</span></div><form @submit.prevent="queryClicked"><div class="fc-filter-grid"><div class="fc-filter-cell">
							<v-text-field clearable dense label="优惠券名称" outlined v-model="query.caption" color="#d9363e" aria-label="优惠券名称">
							</v-text-field>
						</div>
<div class="fc-filter-cell">
							<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
								transition="scale-transition" offset-y
								min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.start" label="创建开始日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined color="#d9363e" aria-label="创建开始日期"></v-text-field>
								</template>
								<v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn" color="#d9363e">
								</v-date-picker>
							</v-menu>
						</div>
<div class="fc-filter-cell">
							<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
								transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.end" label="创建结束日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined color="#d9363e" aria-label="创建结束日期"></v-text-field>
								</template>
								<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn" color="#d9363e">
								</v-date-picker>
							</v-menu>
						</div>
<div class="fc-filter-cell">
							<v-select v-model="query.status" :items="query.statusItems" item-text="text" item-value="value" label="状态" aria-label="状态" dense outlined color="#d9363e"></v-select>
						</div></div><div class="fc-filter-bottom"><span>设置条件后点击查询</span><div class="fc-filter-actions"><v-btn type="submit" depressed color="#d9363e" dark :loading="query.loading"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></div></form></section>
<section class="fc-records" aria-label="优惠券列表"><div class="fc-list-heading"><h3>优惠券列表</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span></div><v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table ft-table ft-coupon_list fc-has-actions"
			disable-pagination hide-default-footer item-key="id" loading-text="正在加载，请稍候…" :mobile-breakpoint="0" no-data-text="暂无符合条件的记录">

			<template v-slot:item.status="{item}">
				<!-- <v-chip small :color="statusColor(item.status)">{{ statusName(item.status) }}
				</v-chip> -->
				<span v-if="item.status=='0'" class="fc-status fc-status-inactive">作废</span>
				<span v-if="item.status=='1'" class="fc-status fc-status-normal">正常</span>
			</template>

			<template v-slot:item.action="{item}">
				<v-btn @click.stop="showUpdate(item)" outlined color="#c93640" small>修改</v-btn>
				<v-btn @click.stop="frozenCoupon(item)" :disabled="item.status !== '1'" outlined color="#c93640" class="ml-2" small>作废</v-btn>
				<v-btn @click.stop="freeCoupon(item)" :disabled="item.status === '1'" outlined color="#c93640" class="ml-2" small>启用</v-btn>

			</template>


<template v-slot:item.faceValue="{item}"><span class="fc-number">{{item.faceValue}}</span></template>
<template v-slot:item.limitAmount="{item}"><span class="fc-number">{{item.limitAmount}}</span></template>
<template v-slot:item.giveCount="{item}"><span class="fc-number">{{item.giveCount}}</span></template>
<template v-slot:item.usedCount="{item}"><span class="fc-number">{{item.usedCount}}</span></template>
</v-data-table><div class="fc-pagination"><div class="fc-page-size"><v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
						outlined v-model="query.size" /><span>条 / 页</span><span class="fc-total">共 {{data.total}} 条</span></div><v-pagination v-if="Math.ceil(data.total/query.size)>0" :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange" :total-visible="7" v-model="query.page" color="#d9363e"/></div></section>
<v-dialog title="添加优惠券" v-model="add.dialog" max-width="600" scrollable>
		<v-card class="fc-dialog-card ft-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-ticket-percent-outline</v-icon></span><div><h2>添加优惠券</h2><p>设置优惠券面值、使用门槛与有效期</p></div><v-spacer/><v-btn icon aria-label="关闭添加优惠券" @click="add.dialog=false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>
			<v-card-text class="fc-dialog-body">
				<v-row dense>

					<v-col cols="12">
						<v-text-field label="优惠券名称" v-model="add.coupon.caption" dense outlined color="#d9363e" aria-label="优惠券名称"></v-text-field>
					</v-col>
					<v-col cols="12">
						<v-text-field label="面值" type="number" v-model="add.coupon.faceValue" dense outlined color="#d9363e" aria-label="面值"></v-text-field>
					</v-col>
					<v-col cols="12">
						<v-text-field label="满多少可以使用" type="number" v-model="add.coupon.limitAmount" dense outlined color="#d9363e" aria-label="满多少可以使用"></v-text-field>
					</v-col>
					<v-col cols="12">
						<v-menu ref="menuExpireDate" v-model="add.menuExpireDate" :close-on-content-click="false"
							transition="scale-transition" offset-y min-width="auto">
							<template v-slot:activator="{ on, attrs }">
								<v-text-field v-model="add.coupon.expireDate" label="过期日期" readonly v-bind="attrs" v-on="on"
									dense clearable outlined color="#d9363e" aria-label="过期日期"></v-text-field>
							</template>
							<v-date-picker v-model="add.coupon.expireDate" locale="zh-cn" @input="add.menuExpireDate=false" no-title scrollable color="#d9363e">
							</v-date-picker>
						</v-menu>
					</v-col>

				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="add.dialog=false" color="#65758c" outlined>取消</v-btn>
				<v-btn @click="submitAdd" class="fc-confirm" color="#d9363e" depressed>确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
<v-dialog title="修改优惠券" v-model="update.dialog" max-width="600" scrollable>
		<v-card class="fc-dialog-card ft-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-ticket-percent-outline</v-icon></span><div><h2>修改优惠券</h2><p>调整优惠券名称、使用门槛与有效期</p></div><v-spacer/><v-btn icon aria-label="关闭修改优惠券" @click="update.dialog=false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>
			<v-card-text class="fc-dialog-body">
				<v-row dense>

					<v-col cols="12">
						<v-text-field label="优惠券名称" v-model="update.coupon.caption" dense outlined color="#d9363e" aria-label="优惠券名称"></v-text-field>
					</v-col>
					<v-col cols="12">
						<v-text-field label="面值" type="number" disabled v-model="update.coupon.faceValue" dense outlined color="#d9363e" aria-label="面值"></v-text-field>
					</v-col>
					<v-col cols="12">
						<v-text-field label="满多少可以使用" type="number" v-model="update.coupon.limitAmount" dense outlined color="#d9363e" aria-label="满多少可以使用"></v-text-field>
					</v-col>

					<v-col cols="12">
						<v-menu ref="menuExpireDate1" v-model="update.menuExpireDate" :close-on-content-click="false"
							transition="scale-transition" offset-y min-width="auto">
							<template v-slot:activator="{ on, attrs }">
								<v-text-field v-model="update.coupon.expireDate" label="过期日期" readonly v-bind="attrs" v-on="on"
									dense clearable outlined color="#d9363e" aria-label="过期日期"></v-text-field>
							</template>
							<v-date-picker v-model="update.coupon.expireDate" locale="zh-cn" @input="update.menuExpireDate=false" no-title scrollable color="#d9363e">
							</v-date-picker>
						</v-menu>
					</v-col>

				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="update.dialog=false" color="#65758c" outlined>取消</v-btn>
				<v-btn @click="submitUpdate" class="fc-confirm" color="#d9363e" depressed>确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog></div>
</template>

<script>

	import utils from "../../../config/utils"
	export default {
		name: "coupon-list",
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '财务中心',
						disabled: true
					},
					{
						text: '优惠券管理',
						disabled: true
					},
				],
				data: {
					total: 0,
					headers: [
						
						{
							text: '优惠券名称',
							value: 'caption',
							sortable: false
						},
						{
							text: '面值',
							value: 'faceValue',
							sortable: false
						},
						{
							text: '使用金额限制',
							value: 'limitAmount',
							sortable: false
						},
						{
							text: '过期日期',
							value: 'expireDate',
							sortable: false
						},
						{
							text: '发放数量',
							value: 'giveCount',
							sortable: false
						},
						{
							text: '已用数量',
							value: 'usedCount',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '操作',
							align: 'center',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					caption: "",
					status:"1",
					statusItems:[
						{value:"",text:"全部"},
						{value:"1",text:"正常"},
						{value:"0",text:"作废"},
					]
				},
				add: {
					dialog: false,
					coupon: {
						caption: "",
						faceValue:"",
						limitAmount:"",
						limitShop:"",
						expireDate:""
					},
					menuExpireDate:false,
				},
				update: {
					dialog: false,
					coupon: {
						id:"",
						caption: "",
						faceValue:"",
						limitAmount:"",
						limitShop:"",
						expireDate:""
					},
					menuExpireDate:false,
				},
			}
		},
		created() {
			this.getTableDataList();
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			showAddDialog() {
				this.add.dialog = true;
				
				// 清空add历史数据
				this.add.coupon.caption = "";
				this.add.coupon.faceValue = "";
				this.add.coupon.limitAmount = "";
				this.add.coupon.expireDate = "";
				
			},
			showUpdate(item){
				this.update.coupon.id = item.id;
				this.update.coupon.caption = item.caption;
				this.update.coupon.faceValue = item.faceValue;
				this.update.coupon.limitAmount = item.limitAmount;
				this.update.coupon.expireDate = item.expireDate;
				
				this.update.dialog = true;
			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;
				
				const shopId = utils.getCurrentShopId();

				let url = `/financial/coupon/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				
				if(shopId){
					url += "&shopId=" + shopId;
				}
				
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.caption) {
					url += "&caption=" + this.query.caption;
				}
				if(this.query.status){
					url += "&status=" + this.query.status;
				}
				
			
				this.axios.get(url).then(response => {
					
					console.log("coupon list res:",response);
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "作废";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
			submitAdd() {

				if (!this.add.coupon.caption) {
					this.$noty.error('优惠券名称不能为空');
					return
				}
				
				if (!this.add.coupon.faceValue) {
					this.$noty.error('金额不能为空');
					return
				}
				
				const shopId = utils.getCurrentShopId();
			
				// api
				const that = this;
				let url = `/financial/coupon/create`;
				let postData = {...this.add.coupon};
				postData.limitShop = shopId;
			

				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.add.dialog = false;
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}

				});

			},
			submitUpdate() {
			
				if (!this.update.coupon.caption) {
					this.$noty.error('优惠券名称不能为空');
					return
				}
				
				// api
				const that = this;
				let url = `/financial/coupon/update`;
				let postData = {...this.update.coupon};
				
			
			
				this.axios.post(url, postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.getTableDataList();
							that.update.dialog = false;
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				});
			},
			
			frozenCoupon(item){
				//冻结
				const that = this;
				let url = `/financial/coupon/frozen/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			freeCoupon(item){
				//解冻
				const that = this;
				let url = `/financial/coupon/free/${item.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			getShopListForSelect(){
				const that = this;
				let url = `/sys/merchant/shop/list`;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectShopList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
		}
	}
</script>

<style lang="scss" scoped src="../../../assets/styles/financial-tools.scss"></style>
